// extracted by mini-css-extract-plugin
export default {"container":"sb08a","title":"df3Uh","text":"qK2Lj","mobile":"rbaYd","subtitle":"J8mpG"};